// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registerContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  background-color: #FFFFFF;
  padding: 20px;
  padding-top: 80px;
}

.registerTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.registerForm {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.formRow {
  display: flex;
  gap: 20px;
  width: 100%;
}

.formGroup {
  flex: 1 1;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

.input {
  width: 100%;
  height: 45px;
  padding: 0 12px;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
}

.input:focus {
  border-color: #FF6F0F;
}

.birthGenderContainer {
  display: flex;
  gap: 15px;
}

.birthGroup {
  flex: 0.6 1;
}

.genderGroup {
  flex: 0.4 1;
}

.genderButtons {
  display: flex;
  gap: 10px;
}

.genderButton {
  width: 50px;
  height: 45px;
  background-color: #F5F5F5;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.genderButton.active {
  background-color: #FF6F0F;
  color: white;
  border-color: #FF6F0F;
}

.lastRow .formGroup:last-child {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.registerButton {
  width: 100%;
  height: 45px;
  padding: 12px;
  background-color: #FF6F0F;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.loginLink {
  margin-top: 20px;
  color: #666666;
  text-decoration: none;
  font-size: 14px;
}

.loginLink:hover {
  color: #3A46B1;
}

/* 앱바 스타일은 Login.css와 공유 */
.appBar {
  display: flex;
  align-items: center;
  height: 60px;
  width: 100%;
  padding: 0 20px;
  background-color: #FFFBF7;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.appBarLogoImage {
  height: 30px;
}

.dialogOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 다이얼로그가 다른 요소 위에 표시되도록 설정 */
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.dialogButton {
  background-color: #FF6F0F; /* 버튼 색상 */
  color: white; /* 텍스트 색상 */
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.labelWithHint {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.inputHint {
  font-size: 12px;
  color: #777;
  font-style: italic;
} 

.coordinates-result {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #FF6F0F;
  font-size: 13px;
  color: #333;
}

.coordinates-result p {
  margin: 4px 0;
}

.address-loading {
  margin-top: 8px;
  font-size: 13px;
  color: #666;
  font-style: italic;
}

.address-error {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fee;
  border-radius: 4px;
  border-left: 3px solid #f44336;
  font-size: 13px;
  color: #d32f2f;
} 

/* 체크박스 스타일 */
.checkboxGroup {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.checkboxLabel {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkboxLabel input[type="checkbox"] {
  margin-right: 8px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.checkboxText {
  font-size: 14px;
  color: #333;
}

.checkboxText.bold {
  font-weight: bold;
}

.termsLink {
  margin-left: 10px;
  font-size: 12px;
  color: #6C80E9;
  text-decoration: underline;
}

/* 인증 확인 버튼 스타일 */
.verifyButton {
  width: 100%;
  height: 45px;
  background-color: #FF6F0F;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.verifyButton:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* 유효성 검사 오류 메시지 스타일 */
.validationError {
  color: #f44336;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0;
}

/* 인증 필요 메시지 스타일 */
.verificationRequired {
  color: #f44336;
  font-size: 13px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 8px;
  background-color: #ffeeee;
  border-radius: 4px;
  border-left: 3px solid #f44336;
}

/* 회원가입 성공 스타일 */
.registrationSuccessContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.successIcon {
  font-size: 80px;
  color: #4CAF50;
  margin-bottom: 20px;
  width: 100px;
  height: 100px;
  background-color: #e8f5e9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.successTitle {
  font-size: 24px;
  color: #333333;
  margin-bottom: 15px;
}

.successMessage {
  font-size: 16px;
  color: #666666;
  margin-bottom: 30px;
}

.loginRedirectButton {
  background-color: #FF6F0F;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 12px 30px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.loginRedirectButton:hover {
  background-color: #e86400;
}

/* 로딩 컨테이너 스타일 */
.loadingContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.loadingSpinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 111, 15, 0.2);
  border-radius: 50%;
  border-top-color: #FF6F0F;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 오류 컨테이너 스타일 */
.errorContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.errorIcon {
  font-size: 80px;
  color: #F44336;
  margin-bottom: 20px;
  width: 100px;
  height: 100px;
  background-color: #ffebee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.errorTitle {
  font-size: 24px;
  color: #333333;
  margin-bottom: 15px;
}

.errorMessage {
  font-size: 16px;
  color: #666666;
  margin-bottom: 30px;
}

/* 비밀번호 재설정 페이지 추가 스타일 */
.resetDescription {
  text-align: center;
  margin-bottom: 30px;
  color: #666666;
  font-size: 16px;
} `, "",{"version":3,"sources":["webpack://./src/styles/Register.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAS;AACX;;AAEA;EACE,WAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY,EAAE,WAAW;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".registerContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100vh;\n  background-color: #FFFFFF;\n  padding: 20px;\n  padding-top: 80px;\n}\n\n.registerTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.registerForm {\n  width: 100%;\n  max-width: 900px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formRow {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n}\n\n.formGroup {\n  flex: 1;\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #333;\n}\n\n.input {\n  width: 100%;\n  height: 45px;\n  padding: 0 12px;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  font-size: 16px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.input:focus {\n  border-color: #FF6F0F;\n}\n\n.birthGenderContainer {\n  display: flex;\n  gap: 15px;\n}\n\n.birthGroup {\n  flex: 0.6;\n}\n\n.genderGroup {\n  flex: 0.4;\n}\n\n.genderButtons {\n  display: flex;\n  gap: 10px;\n}\n\n.genderButton {\n  width: 50px;\n  height: 45px;\n  background-color: #F5F5F5;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.genderButton.active {\n  background-color: #FF6F0F;\n  color: white;\n  border-color: #FF6F0F;\n}\n\n.lastRow .formGroup:last-child {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.registerButton {\n  width: 100%;\n  height: 45px;\n  padding: 12px;\n  background-color: #FF6F0F;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.loginLink {\n  margin-top: 20px;\n  color: #666666;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.loginLink:hover {\n  color: #3A46B1;\n}\n\n/* 앱바 스타일은 Login.css와 공유 */\n.appBar {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  width: 100%;\n  padding: 0 20px;\n  background-color: #FFFBF7;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.appBarLogoImage {\n  height: 30px;\n}\n\n.dialogOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* 다이얼로그가 다른 요소 위에 표시되도록 설정 */\n}\n\n.dialog {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.dialogButton {\n  background-color: #FF6F0F; /* 버튼 색상 */\n  color: white; /* 텍스트 색상 */\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.labelWithHint {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.inputHint {\n  font-size: 12px;\n  color: #777;\n  font-style: italic;\n} \n\n.coordinates-result {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border-left: 3px solid #FF6F0F;\n  font-size: 13px;\n  color: #333;\n}\n\n.coordinates-result p {\n  margin: 4px 0;\n}\n\n.address-loading {\n  margin-top: 8px;\n  font-size: 13px;\n  color: #666;\n  font-style: italic;\n}\n\n.address-error {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: #fee;\n  border-radius: 4px;\n  border-left: 3px solid #f44336;\n  font-size: 13px;\n  color: #d32f2f;\n} \n\n/* 체크박스 스타일 */\n.checkboxGroup {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.checkboxLabel input[type=\"checkbox\"] {\n  margin-right: 8px;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.checkboxText {\n  font-size: 14px;\n  color: #333;\n}\n\n.checkboxText.bold {\n  font-weight: bold;\n}\n\n.termsLink {\n  margin-left: 10px;\n  font-size: 12px;\n  color: #6C80E9;\n  text-decoration: underline;\n}\n\n/* 인증 확인 버튼 스타일 */\n.verifyButton {\n  width: 100%;\n  height: 45px;\n  background-color: #FF6F0F;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.verifyButton:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* 유효성 검사 오류 메시지 스타일 */\n.validationError {\n  color: #f44336;\n  font-size: 12px;\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n/* 인증 필요 메시지 스타일 */\n.verificationRequired {\n  color: #f44336;\n  font-size: 13px;\n  text-align: center;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  padding: 8px;\n  background-color: #ffeeee;\n  border-radius: 4px;\n  border-left: 3px solid #f44336;\n}\n\n/* 회원가입 성공 스타일 */\n.registrationSuccessContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  width: 100%;\n}\n\n.successIcon {\n  font-size: 80px;\n  color: #4CAF50;\n  margin-bottom: 20px;\n  width: 100px;\n  height: 100px;\n  background-color: #e8f5e9;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.successTitle {\n  font-size: 24px;\n  color: #333333;\n  margin-bottom: 15px;\n}\n\n.successMessage {\n  font-size: 16px;\n  color: #666666;\n  margin-bottom: 30px;\n}\n\n.loginRedirectButton {\n  background-color: #FF6F0F;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 12px 30px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.loginRedirectButton:hover {\n  background-color: #e86400;\n}\n\n/* 로딩 컨테이너 스타일 */\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  text-align: center;\n}\n\n.loadingSpinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 111, 15, 0.2);\n  border-radius: 50%;\n  border-top-color: #FF6F0F;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* 오류 컨테이너 스타일 */\n.errorContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  width: 100%;\n}\n\n.errorIcon {\n  font-size: 80px;\n  color: #F44336;\n  margin-bottom: 20px;\n  width: 100px;\n  height: 100px;\n  background-color: #ffebee;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.errorTitle {\n  font-size: 24px;\n  color: #333333;\n  margin-bottom: 15px;\n}\n\n.errorMessage {\n  font-size: 16px;\n  color: #666666;\n  margin-bottom: 30px;\n}\n\n/* 비밀번호 재설정 페이지 추가 스타일 */\n.resetDescription {\n  text-align: center;\n  margin-bottom: 30px;\n  color: #666666;\n  font-size: 16px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
